export const ACT_TYPE_SPIN_LUCK = 1 //幸运转盘
export const ACT_TYPE_RED_ENVELOPE_RAIN = 2 //红包雨
export const ACT_TYPE_SIGN_IN = 4 //签到活动
export const ACT_TYPE_AGENT_REWARD_BOX = 6 //代理宝箱
export const ACT_TYPE_LOSS_CASHBACK = 7 //亏损返现
export const ACT_TYPE_TOTAL_DEPOSIT_REWARD = 8 //累计存款奖励
export const ACT_TYPE_FIRST_DEPOSIT_REWARD = 9 //首次存款奖励

export const ACT_TYPE_LINK = 10000
